module.exports = function getResource(label) {
    let resources = {
        sameDayDelivery: 'Livraison le jour même ',
        standard: 'Standard ',
        item: 'Article',
        items: 'Articles'
    };

    return resources[label];
};
